"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.goodsDelete = goodsDelete;
exports.goodsDetail = goodsDetail;
exports.goodsList = goodsList;
exports.goodsSave = goodsSave;
exports.goodsSearch = goodsSearch;
exports.goodsStatus = goodsStatus;
exports.goodsStock = goodsStock;
var _request = _interopRequireDefault(require("@/utils/request"));
// 超级补贴商品列表
function goodsList(params) {
  return (0, _request.default)({
    url: '/portal/system/supersubsidy/goods',
    method: 'get',
    params: params
  });
}
// 超级补贴商品详情
function goodsDetail(params) {
  return (0, _request.default)({
    url: '/portal/system/supersubsidy/goodsdetail',
    method: 'get',
    params: params
  });
}
// 超级补贴商品解析（渠道 + 口令/链接/纯商品ID）
function goodsSearch(params) {
  return (0, _request.default)({
    url: '/portal/system/supersubsidy/search',
    method: 'get',
    params: params
  });
}
// 超级补贴商品保存（有 id 为编辑，无 id 为新建）
function goodsSave(data) {
  return (0, _request.default)({
    url: '/portal/system/supersubsidy/goods',
    method: 'post',
    data: data
  });
}
// 超级补贴商品上下架
function goodsStatus(data) {
  return (0, _request.default)({
    url: '/portal/system/supersubsidy/status',
    method: 'post',
    data: data
  });
}
// 超级补贴商品库存调整
function goodsStock(data) {
  return (0, _request.default)({
    url: '/portal/system/supersubsidy/stock',
    method: 'post',
    data: data
  });
}
// 超级补贴商品删除
function goodsDelete(data) {
  return (0, _request.default)({
    url: '/portal/system/supersubsidy/goodsdel',
    method: 'post',
    data: data
  });
}